import resourceBaseUrl from './baseUrl'

const computeSha256Hex = async (data: Blob): Promise<string> => {
  const buffer = await data.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export type UploadResourceParams = {
  data: Blob
  extension: string
}

const uploadResource = async ({ data, extension }: UploadResourceParams): Promise<string> => {
  const sha256hex = await computeSha256Hex(data)
  const resourceKey = `${sha256hex}.${extension}`

  const response = await fetch(`${resourceBaseUrl}/resources/${resourceKey}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/octet-stream' },
    body: data,
  })

  if (!response.ok) {
    throw new Error(`Failed to upload resource: ${response.status} ${response.statusText}`)
  }

  return resourceKey
}

export default uploadResource
